import {
    ComponentElements,
    ComponentInjector,
    ComponentObject,
    ComponentSelector,
    ComponentService,
    UIComponent,
    ComponentSelectors,
} from '@atypon/ui-utils';

class Texts extends ComponentObject { }

class ClassList extends ComponentObject { }

class Selectors extends ComponentSelectors {
    tabs = new ComponentSelector('[role=tab]');
    defualtTab = '[data-default-tab]';
}

class Elements extends ComponentElements<Selectors> {
    tabs: Array<HTMLElement> = [];
    tabpanels: Array<HTMLElement> = [];
    firstTab : HTMLElement;
    lastTab : HTMLElement;
}

interface TabsA11y extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class TabsA11y implements UIComponent {

    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.initialize(this.wrapper);
        this.addEventListeners();
        this.elements.firstTab?.closest(this.selectors.defualtTab) || this.setSelectedTab(this.elements.firstTab, false);

    }


    addEventListeners(): void {
        this.setTabPannels();
    }

    setTabPannels () : void {
        this.elements.tabs.forEach((tab)=>{
            let tabpanel = this.domUtils.getElementById(tab.getAttribute('aria-controls'));
            tab.tabIndex = -1;
            tab.setAttribute('aria-selected', 'false');
            this.elements.tabpanels.push(tabpanel);

            tab.addEventListener('keydown', this.onKeydown.bind(this));
            tab.addEventListener('click', this.onClick.bind(this));

            if (!this.elements.firstTab) {
                this.elements.firstTab = tab;
            }
            this.elements.lastTab = tab;
        })
    }

    setSelectedTab(currentTab, setFocus?) : void {
        if (typeof setFocus !== 'boolean') {
            setFocus = true;
        }
        for (let i = 0; i < this.elements.tabs.length; i += 1) {
            let tab = this.elements.tabs[i];
            if (currentTab === tab) {
                tab.setAttribute('aria-selected', 'true');
                tab.removeAttribute('tabindex');
                tab.parentElement.classList.add('active');
                this.elements.tabpanels[i]?.classList.add('active');
                if (setFocus) {
                    tab.focus();
                }
            } else {
                tab.setAttribute('aria-selected', 'false');
                tab.tabIndex = -1;
                tab.parentElement.classList.remove('active');
                this.elements.tabpanels[i]?.classList.remove('active');
            }
        }
    }

    setSelectedToPreviousTab(currentTab) : void {
        let index;

        if (currentTab === this.elements.firstTab) {
            this.setSelectedTab(this.elements.lastTab);
        } else {
            index = this.elements.tabs.indexOf(currentTab);
            this.setSelectedTab(this.elements.tabs[index - 1]);
        }
    }

    setSelectedToNextTab(currentTab) : void {
        let index;

        if (currentTab === this.elements.lastTab) {
            this.setSelectedTab(this.elements.firstTab);
        } else {
            index = this.elements.tabs.indexOf(currentTab);
            this.setSelectedTab(this.elements.tabs[index + 1]);
        }
    }

    onKeydown(event) : void {
        let tgt = event.currentTarget,
            flag = false;

        switch (event.key) {
            case 'ArrowDown':
            case 'ArrowLeft':
                this.setSelectedToPreviousTab(tgt);
                flag = true;
                break;

            case 'ArrowUp':
            case 'ArrowRight':
                this.setSelectedToNextTab(tgt);
                flag = true;
                break;

            case 'Home':
                this.setSelectedTab(this.elements.firstTab);
                flag = true;
                break;

            case 'End':
                this.setSelectedTab(this.elements.lastTab);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    onClick(event) : void {
        this.setSelectedTab(event.currentTarget);
    }

}

export default TabsA11y;
